import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    grand_total: null,
    qty_total: null,
    negative_qty_total: null,
    date: null,
    time: null,
    searchMeta: null,
    filters: [],
};

const getters = {
    grandTotal: state => state.grand_total,

    qtyTotal: state => state.qty_total,

    negativeQtyTotal: state => state.negative_qty_total,

    date: state => state.date,

    time: state => state.time,

    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setGrandTotal(state, data) {
        state.grand_total = data;
    },

    setTotalQty(state, data) {
        state.qty_total = data;
    },

    setNegativeTotalQty(state, data) {
        state.negative_qty_total = data;
    },

    setDate(state, date) {
        state.date = date;
    },

    setTime(state, time) {
        state.time = time;
    },

    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },
};

const actions = {
    async getGrandTotal({ commit, dispatch }, filterParams) {
        startLoading(dispatch, 'fetch-summary');
        let url = Laroute.route('inventory.stock-cost.summary');
        url += `?${filterParams}`;

        try {
            const { data } = await axios.get(url);

            endLoading(dispatch, 'fetch-summary');
            commit('setGrandTotal', data.total_inventory_value);
            commit('setTotalQty', data.stock_on_hand);
            commit('setNegativeTotalQty', data.negative_stocks);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-summary');
            throw e;
        }
    },

    storeDate({ commit }, date) {
        commit('setDate', date);
    },

    storeTime({ commit }, time) {
        commit('setTime', time);
    },

    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route('inventory.stock-cost.search.meta');

        startLoading(dispatch, 'get-stock-cost-meta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-stock-cost-meta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-stock-cost-meta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/inventory-stock-cost.js